export default __webpack_public_path__ + "static/media/5.5a664b7d.png";